import { h, Component } from 'preact'
import TrackingLink from '../link/tracking-link'
import Phrase from '../../libs/translationsUtils/phrase'
import LazyLoader from '../lazy-loading/LazyLoader'

interface Props {
  title: string,
  badges: Array<{
    title: string,
    image: string,
    username: string,
    userUrl: string,
  }>
}

export default class BadgesEarned extends Component<Props> {
  render (props: Props) {
    if (!props.badges.length) return null
    return <div class='box widget widget--badges qa-widget-badges'>
      <div class='box__content box__pad'>
        {props.title ? <h3 class='widget-title'>{props.title}</h3> : null}
        <TrackingLink
          tag='ul'
          track={{'type': 'Sidebar Widget Clicked', 'widget': 'badges'}}
          gaEvents={{'eventCategory': 'Homepage', 'eventAction': 'Widget Clicked', 'eventLabel': {'Type': 'Badges'}}}
          class='list list--badges unpad--sidebar qa-badges-earned-list'
        >
          {props.badges.map(badge => {
            return <li>
              <div class='user flag flag--top'>
                <div class='flag__image'>
                  <LazyLoader type='img' src={badge.image} title={badge.title} alt={badge.title} />
                </div>
                <div class='user_data flag__body'>
                  <a class='link username' href={badge.userUrl}>{badge.username}</a>
                  <span class='text--meta'><Phrase p='has earned the badge {badgetitle}' count={{'badgetitle': badge.title}} /></span>
                </div>
              </div>
            </li>
          })}
        </TrackingLink>
        <a class='link link--underline' href='/badges'><Phrase p='Show all badges' /></a>
      </div>
    </div>
  }
}
